import { render, staticRenderFns } from "./DataGridV3.vue?vue&type=template&id=9cf5b282&scoped=true"
import script from "./DataGridV3.vue?vue&type=script&lang=js"
export * from "./DataGridV3.vue?vue&type=script&lang=js"
import style0 from "./DataGridV3.vue?vue&type=style&index=0&id=9cf5b282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf5b282",
  null
  
)

export default component.exports